"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polymorphicStyles = exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

// based on Mantine:
// https://mantine.dev/guides/polymorphic/
// https://github.com/mantinedev/mantine/blob/master/src/mantine-core/src/core/factory/create-polymorphic-component.ts

var createPolymorphicComponent = function createPolymorphicComponent(component) {
  return component;
};
var polymorphicStyles = exports.polymorphicStyles = {
  margin: 0,
  padding: 0,
  background: "none",
  border: "none",
  borderRadius: 0,
  color: "unset",
  font: "unset",
  textAlign: "unset",
  lineHeight: 1,
  textDecoration: "none"
};
var _default = exports.default = createPolymorphicComponent;